import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-img",
  "use": "icon-img-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-img\">\n<path d=\"M5.33333 48H42.6667C44.0812 48 45.4377 47.4381 46.4379 46.4379C47.4381 45.4377 48 44.0812 48 42.6667V5.33333C48 3.91885 47.4381 2.56229 46.4379 1.5621C45.4377 0.561903 44.0812 0 42.6667 0H5.33333C3.91885 0 2.56229 0.561903 1.5621 1.5621C0.561903 2.56229 0 3.91885 0 5.33333V42.6667C0 44.0812 0.561903 45.4377 1.5621 46.4379C2.56229 47.4381 3.91885 48 5.33333 48ZM13.3333 29.3333L19.6347 35.6347L29.3333 21.3333L42.6667 40H5.33333L13.3333 29.3333Z\" fill=\"#919BA8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/img.svg
// module id = 4bdm
// module chunks = 258